<script>
export default {
    bind: function (el) {
        el.oninput = function(e) {
            if (!e.isTrusted) {
                return;
            }

            let raw_value = this.value.replace(/\D/g, ''); // Убираем все нецифровые символы

            // Если первое число 7 или 8 — удаляем его
            if (raw_value.startsWith('7') || raw_value.startsWith('8')) {
                raw_value = raw_value.slice(1);
            }

            // Если поле пустое, ничего не форматируем
            if (!raw_value) {
                this.value = '';
                el.dispatchEvent(new Event('input'));
                return;
            }

            // Форматирование номера телефона
            const x = raw_value.match(/(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/);
            this.value = x[1] +
                (x[2] ? ' ' + x[2] : '') +
                (x[3] ? '-' + x[3] : '') +
                (x[4] ? '-' + x[4] : '');

            el.dispatchEvent(new Event('input'));
        };
    }
};
</script>
